// extracted by css-extract-rspack-plugin
export default {"Wrapper":"BadgeEarnedPopup_Wrapper__yEbz3","Confetti":"BadgeEarnedPopup_Confetti__pthJN"};